import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import { IconClose } from "app/components/Icon/Icon";
import OddsFormatter from "app/components/OddsFormatter/OddsFormatter";
import { MultiplesHelper } from "app/helpers/multiplesHelper";
import { BetSlipType } from "app/types/betSlipType";
import { MultiplesBetSlipType } from "app/types/multiplesBetSlipType";
import { OddsType } from "app/utils/const";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import "../../../BetSlipList/components/BetSlip/components/BetSlipCompleted/BetSlipCompleted.scss";
import "./MultiplesBetSlipCompleted.scss";

type Props = {
  reportList: any;
  clearMultiples: Function;
  multiplierName: string;
  oddsTotal: number;
  requestedStake: string;
  stake: string;
  profit: string;
  oddsType: string;
  decimalOdds: number;
  multiplesBetSlipList: MultiplesBetSlipType[];
  betSlipList: BetSlipType[];
  removeBetSlip: Function;
};

class MultiplesBetSlipCompleted extends Component<Props> {
  onDelete = (ev: Event) => {
    if (ev != null) {
      ev.preventDefault();
    }
    // remove corresponsing single bets from bet slip panel
    MultiplesHelper.removeCorrespondingSingleBets();
    this.props.clearMultiples();
  };

  render() {
    const { multiplierName, oddsTotal, stake, profit, oddsType, decimalOdds } =
      this.props;

    return (
      <div className="bet-slip-completed multiples-bet-slip-completed">
        <div className="bet-slip-completed__header">
          <div className="bet-slip-completed__header__text">
            <FormattedMessage tagName="span" id="bets-betaccepted" />
          </div>
          <div
            className="bet-slip-completed__header__close"
            onClick={ev => this.onDelete(ev)}
          >
            <IconClose />
          </div>
        </div>
        <div>
          <FormattedMessage tagName="span" id="bet-betslip-multiples" />-{" "}
          {multiplierName}
          <br />
          <FormattedMessage tagName="span" id="prices-odds" />:{" "}
          <span data-qa="confirmed_bet_slip_odds">
            {oddsType === OddsType.MALAY ? (
              <OddsFormatter odds={decimalOdds} />
            ) : (
              oddsTotal
            )}
          </span>
          <br />
          <CurrencyNumber value={stake} />{" "}
          <FormattedMessage tagName="span" id="bets-of" />{" "}
          <CurrencyNumber value={this.props["requestedStake"]} />{" "}
          <FormattedMessage tagName="span" id="bets-stake-accepted" />
          <br />
          <FormattedMessage tagName="span" id="bets-return" />{" "}
          <CurrencyNumber value={profit} />
          <br />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  multiplesBetSlipList: state.multiplesBetSlipListModel.multiplesBetSlipList,
  multiplierName: state.multiplesBetSlipListModel.multiplierName,
  maxStake: state.multiplesBetSlipListModel.maxStake,
  maxReturn: state.multiplesBetSlipListModel.maxReturn,
  oddsTotal: state.multiplesBetSlipListModel.oddsTotal,
  message: state.multiplesBetSlipListModel.message,
  requestedStake: state.multiplesBetSlipListModel["requestedStake"],
  stake: state.multiplesBetSlipListModel.stake,
  canSubmit: state.multiplesBetSlipListModel.canSubmit,
  status: state.multiplesBetSlipListModel.status,
  profit: state.multiplesBetSlipListModel.profit,
  oddsType: state.multiplesBetSlipListModel.oddsType,
  decimalOdds: state.multiplesBetSlipListModel.decimalOdds,
  betSlipList: state.betSlipListModel.betSlipList,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    clearMultiples: () => {
      dispatch.multiplesBetSlipListModel.clearMultiples();
    },
    removeBetSlip: localId => dispatch.betSlipListModel.removeBetSlip(localId),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiplesBetSlipCompleted) as any;
